import { AutoComplete, Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

const SearchOptions = ({
  SearchResult,
  onSelect,
  placeholder,
  title,
  defaultValue,
  value,
  refInput,
  SelectWidth,
  enterButtonSize,
  searchWidth = '300px',
}: {
  SearchResult: any;
  onSelect: any;
  placeholder: string;
  title?: string;
  defaultValue?: string | undefined;
  value?: string;
  refInput?: any;
  SelectWidth?: any;
  enterButtonSize?: string;
  searchWidth?: string;
}) => {
  const [options, setOptions] = useState<Array<any>>([]);
  const [state, setState] = useState(value);
  useEffect(() => {
    setState(value);
  }, [value]);

  const debounce = (func: any) => {
    let timer: any;
    return function (...args: any) {
      // const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func(args[0]);
      }, 1000);
    };
  };

  const handleSearch = async (value: string) => {
    if (value) {
      let data = await SearchResult(value);
      if (data.length === 0) {
        data = [{ value: 'Not found', label: 'Not found ', key: 'no-found' }];
      }
      setOptions(data);
    } else {
      setOptions([]);
    }
  };

  const optimizedFn = useCallback(debounce(handleSearch), []);

  return (
    <AutoComplete
      popupMatchSelectWidth={SelectWidth}
      style={{ width: searchWidth, marginRight: '15px' }}
      options={options}
      onSelect={onSelect}
      onSearch={optimizedFn}
      defaultValue={defaultValue}
      onChange={onSelect}
      value={state}
    >
      <Input.Search
        className={enterButtonSize ? 'custom-search-input' : ''}
        ref={refInput}
        placeholder={placeholder}
        title={title}
        allowClear
        enterButton
      />
    </AutoComplete>
  );
};

export default SearchOptions;
